import type { ReactNode } from 'react'

/**
 * The page's own heading block. Fraunces earns its place exactly here.
 *
 * `items-start`, not `items-end`: the action slot holds a status pill ("server
 * ready", "refreshing 3"), and aligning it to the BOTTOM of a two-line lede
 * left it floating in the middle of the header with nothing to relate to. It
 * belongs on the title's line — that is what it is a status for.
 *
 * This file used to be `placeholder.tsx` and also exported a `Placeholder`
 * scaffold marker. Every screen it marked has been built, so the marker is
 * gone; a scaffold component surviving into a finished app is how a demo ends
 * up shipping with "TODO" on a page nobody re-read.
 */
export function PageHeader({
  title,
  lede,
  actions,
}: {
  title: string
  lede?: ReactNode
  actions?: ReactNode
}) {
  return (
    <div className="mb-8 flex flex-wrap items-start justify-between gap-x-6 gap-y-3">
      <div className="max-w-2xl space-y-2">
        <h1 className="display text-3xl text-ink sm:text-4xl">{title}</h1>
        {lede ? <p className="text-[0.9375rem] leading-relaxed text-ink-muted">{lede}</p> : null}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2 pt-1.5">{actions}</div> : null}
    </div>
  )
}
